import {onActivated, onDeactivated, onMounted, onUnmounted,} from "vue"
import {useAppUiStore,} from "@/assets/js/src/pinia/appUi"
import {getActivePinia,} from "pinia"

export const useTopClass = (topClass) => {
    let activePinia = getActivePinia()
    let appUiStore = useAppUiStore(activePinia)

    if(typeof topClass === 'string') {
        topClass = [ topClass, ]
    }

    const add = () => {
        topClass.forEach(oneClass => appUiStore.addTopClass(oneClass))
    }

    const remove = () => {
        topClass.forEach(oneClass => appUiStore.removeTopClass(oneClass))
    }

    onMounted(add)
    onUnmounted(remove)

    onActivated(add)
    onDeactivated(remove)
}
